"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TodoItem = exports.Todo = void 0;
var todo_1 = require("./todo");
Object.defineProperty(exports, "Todo", { enumerable: true, get: function () { return __importDefault(todo_1).default; } });
var todo_item_1 = require("./todo.item");
Object.defineProperty(exports, "TodoItem", { enumerable: true, get: function () { return __importDefault(todo_item_1).default; } });
//# sourceMappingURL=index.js.map